export enum NewRegistrationStatus {
  Pending = "Pending",
  Deleted = "Deleted",
  Completed = "Completed",
  RegistrationStarted = "RegistrationStarted"
}
